import { createContext } from 'react'

const plaidContext = createContext()

export default plaidContext
